var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mx-auto",attrs:{"tile":""}},[_c('v-list',{attrs:{"dense":""}},[_c('v-subheader'),_c('v-btn',{on:{"click":function($event){return _vm.Login()}}},[_vm._v("登入")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }